export const SET_CART_LOADING = 'app/cart/SET_CART_LOADING';
export const CART_REDUCER = 'Cart';
